var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobotCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "135px",
    height: "150px",
    viewBox: "0 0 135 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "robot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E0E1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879899",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E0E1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879899",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Unsubscribe-Page---check-the-box",
    transform: "translate(-572.000000, -209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "robot",
    transform: "translate(568.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(29.000000, 43.901414) scale(1, -1) rotate(-16.000000) translate(-29.000000, -43.901414) translate(7.000000, 15.901414)",
    fill: "#D83F1D"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.28888889,
    cy: 3.64285714,
    rx: 3.64444444,
    ry: 3.64285714
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(28.421751, 7.776060) rotate(15.000000) translate(-28.421751, -7.776060) ",
    x: 13.8439729,
    y: 4.13320299,
    width: 29.1555556,
    height: 7.28571429,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.64444444,
    y: 9.71428571,
    width: 7.28888889,
    height: 30.3571429,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64444444,55.8306497 C1.45272856,54.4280657 2.72848411e-12,51.9728961 2.72848411e-12,49.1785714 C2.72848411e-12,44.8194668 3.53529227,41.2857143 7.8962963,41.2857143 C12.2573003,41.2857143 15.7925926,44.8194668 15.7925926,49.1785714 C15.7925926,51.9728961 14.339864,54.4280657 12.1481481,55.8306497 L12.1481481,47.3571429 L3.64444444,47.3571429 L3.64444444,55.8306497 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(113.681933, 94.433873) scale(1, -1) rotate(162.000000) translate(-113.681933, -94.433873) translate(92.181933, 66.433873)",
    fill: "#D83F1D"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.28888889,
    cy: 3.64285714,
    rx: 3.64444444,
    ry: 3.64285714
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 13.362963,
    y: 1.21428571,
    width: 29.1555556,
    height: 7.28571429,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.64444444,
    y: 9.71428571,
    width: 7.28888889,
    height: 30.3571429,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64444444,55.8306497 C1.45272856,54.4280657 0,51.9728961 0,49.1785714 C0,44.8194668 3.53529227,41.2857143 7.8962963,41.2857143 C12.2573003,41.2857143 15.7925926,44.8194668 15.7925926,49.1785714 C15.7925926,51.9728961 14.339864,54.4280657 12.1481481,55.8306497 L12.1481481,47.3571429 L3.64444444,47.3571429 L3.64444444,55.8306497 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.891744, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(22.494800, 0.155707)",
    fill: "#D83F1D"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 3.66666667,
    cy: 3.51503759,
    rx: 3.66666667,
    ry: 3.51503759
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1.46666667,
    y: 8.63694952,
    width: 4.4,
    height: 18.0773362,
    rx: 1.8
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8,20.8571429 L47,20.8571429 C51.418278,20.8571429 55,24.4388649 55,28.8571429 L55,50 L-3.63797881e-12,50 L-3.63797881e-12,28.8571429 C-3.63851989e-12,24.4388649 3.581722,20.8571429 8,20.8571429 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 36.469503,
    cy: 38.09266,
    rx: 4.27777778,
    ry: 4.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#FFFFFF",
    cx: 19.469503,
    cy: 38.09266,
    rx: 4.27777778,
    ry: 4.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(34.425242, 53.292561)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-2)",
    x: 0,
    y: 0,
    width: 73,
    height: 79,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 17.6582271,
    y: 14.8858917,
    width: 38,
    height: 35,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "ban-icon-redone",
    transform: "translate(23.574758, 19.707439)",
    stroke: "#008B8B",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13,
    cy: 13,
    r: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,21.43 L21.5,5.5",
    id: "Line-2",
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(27.672334, 136.842660)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D83F1D",
    x: 0,
    y: 0,
    width: 87,
    height: 13,
    rx: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 7.85416667,
    cy: 6.5,
    rx: 4.22916667,
    ry: 4.13636364
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 22.3541667,
    cy: 6.5,
    rx: 4.22916667,
    ry: 4.13636364
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 36.8541667,
    cy: 6.5,
    rx: 4.22916667,
    ry: 4.13636364
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 50.1458333,
    cy: 6.5,
    rx: 4.22916667,
    ry: 4.13636364
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 64.6458333,
    cy: 6.5,
    rx: 4.22916667,
    ry: 4.13636364
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 79.1458333,
    cy: 6.5,
    rx: 4.22916667,
    ry: 4.13636364
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotCancel);
export default __webpack_public_path__ + "static/media/robot_cancel.a5c05219e35ad8f8e7f39db418204dd1.svg";
export { ForwardRef as ReactComponent };